import { Language } from '@yleisradio/areena-types';

/*
 * Content needs to be valid XHTML because of HBBTV-support, verify any changes with this setup!
 */
export const contactPageHtml: Record<Language, string> = {
  fi: `
    <h1>Ota yhteyttä</h1>
    <p>
      <div>
        Ylen asiakaspalvelu <b>asiakaspalvelu.yle.fi</b>
      </div>
      <div>
        Soita Ylen vaihteeseen <b> puh. 09 14801 </b>
      </div>
      <div class="small-text">
        (tietosuojaseloste
        https://yle.fi/aihe/yleisradio/ylen-puhelinvaihteen-tietosuojaseloste)
      </div>
      <div>
        Lähetä sähköpostia <b>etunimi.sukunimi@yle.fi</b>
      </div>
      <p>
        Yleisradio Oy on sijoittautunut Suomeen. 
        Keskeiset audiovisuaalisten sisältöpalvelujen tarjoamista ja radio- ja 
        televisiotoiminnan harjoittamista valvovat viranomaiset Suomessa ovat 
        Liikenne- ja viestintävirasto Traficom (www.traficom.fi), 
        Kilpailu- ja kuluttajavirasto (www.kkv.fi) ja Kansallinen audiovisuaalinen instituutti (https://kavi.fi/). 
        Yleisradion osakkeista 99,98 prosenttia omistaa Suomen valtio.
      </p>
      <p>
        Tutustu palveluihin verkossa osoitteessa <b>yle.fi</b> tai <b>areena.yle.fi</b>
      </p>
    </p>
  `,
  sv: `
    <h1>Kontakta oss</h1>
    <p>
      <div>
        Kontakta Yles kundservice kundservice.yle.fi/csp
      </div>
      <div>
        Svenska Yles publiktelefon +358 9 1480 4653 må-to kl. 10–12
      </div>
      <div>
        E-post på kundservice@yle.fi eller nyheter@yle.fi (nyhetstips)
      </div>
      <div>
        Yles växel +358 9 14801
      </div>
      <p>
        E-postadresser fungerar enligt principen fornamn.efternamn@yle.fi.
      </p>
      <p>
        Rundradion Ab är beläget i Finland. De centrala myndigheter som 
        övervakar tillhandahållandet av audiovisuella innehållstjänster 
        och radio- och tv-verksamhet i Finland är Transport- och kommunikationsverket 
        Traficom (www.traficom.fi), Konkurrens- och konsumentverket (www.kkv.fi) 
        och Nationella audiovisuella institutet (https://kavi.fi/). 
        99,98 procent av Rundradions aktier ägs av den finska staten.
      </p>
      <p>
        Bekanta dig med svenska.yle.fi | arenan.yle.fi
      </p>
    </p>
  `,
};
